import { Box, BoxProps, styled, Theme } from "@mui/material";
import React from "react";

interface ChipProps {
  children: React.ReactNode;
}

const StyledChip = styled(Box)<BoxProps>(({ theme }: { theme: Theme }) => ({
  display: "inline-block",
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
  borderRadius: "8px",
  padding: "4px 12px",
  fontSize: "0.875rem",
  fontWeight: 500,
  position: "relative",
  width: "fit-content",
  height: "30px",
  alignSelf: "center",
  // shift the pseudo‐element down below the “pill”
  "&::after": {
    content: '""',
    position: "absolute",
    bottom: -6, // pulls the small triangle 6px below the box
    left: "50%",
    transform: "translateX(-50%)",
    width: 0,
    height: 0,
    borderLeft: "6px solid transparent",
    borderRight: "6px solid transparent",
    borderTop: `6px solid ${theme.palette.primary.main}`,
  },
}));

const PointerChip = ({ children }: ChipProps) => {
  return <StyledChip>{children}</StyledChip>;
};

export default PointerChip;
